import { useCallback } from 'react';
import { keychain } from 'shared/library/keychain';
import { clearListingPreviews } from 'shared/state/listing-preview';
import { useBreederStoreApi } from 'shared/state/breeder';
import useContractWizardStore from 'shared/state/contract-wizard';
import useConversationWizardStore from 'shared/state/conversation-wizard';
import useInboxStore from 'shared/state/inbox';
import useLikesStore from 'shared/state/likes';
import useListingWizardStore from 'shared/state/listing-wizard';
import useLocationStore from 'shared/state/location';
import useLoginStore from 'shared/state/login';
import useOnboardingWizardStore from 'shared/state/onboarding-wizard';
import useSearchesStore from 'shared/state/searches';
import { useShopStoreApi } from 'shared/state/shop';
import { useUserStoreApi } from 'shared/state/user';

export function useResetAuthenticatedState() {
  const userStore = useUserStoreApi();
  const breederStore = useBreederStoreApi();
  const shopStore = useShopStoreApi();

  return useCallback(async () => {
    await import('shared/components/chat/disconnect-chat-session')
      .then(({ disconnectChatSession }) => disconnectChatSession())
      .catch(() => undefined); // Offline chunk loading must not prevent signing out.
    await keychain.removeAndWait('apiKey');

    useInboxStore.getState().reset();
    breederStore.getState().reset();
    useLikesStore.getState().reset();
    useSearchesStore.getState().reset();
    useLoginStore.getState().reset();
    useLocationStore.getState().reset();
    useListingWizardStore.getState().reset();
    useConversationWizardStore.getState().reset();
    useContractWizardStore.getState().reset();
    useOnboardingWizardStore.getState().reset();
    shopStore.getState().reset();
    clearListingPreviews();
    userStore.getState().reset();
  }, [breederStore, shopStore, userStore]);
}
